module.exports = new __parcel__URL__("battlepass_raffle_inactive_button.e3491eda.png").toString();